import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login'
import Home from '../views/Home'
import ProspectsAdd from '../views/ProspectsAdd'
import Prospects from '../views/Prospects'
import LeadAdd from '../views/LeadAdd'
import NotFound from '../views/NotFound'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/prospects/add',
    name: 'ProspectsAdd',
    component: ProspectsAdd
  },
  {
    path: '/prospects',
    name: 'Prospects',
    component: Prospects
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/lead/add',
    name: 'LeadAdd',
    component: LeadAdd
  },
  {
    path: '/notFound',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.name === 'LeadAdd') {
    if (!store.getters.isAuthenticated) {
      const { token } = to.query
      store.dispatch('checkLead', token)
      next()
    } else {
      next({ name: 'Home' })
    }
  } else if (to.name !== 'Login' && to.name !== 'LeadAdd' && to.name !== 'NotFound' && !store.getters.isAuthenticated) {
    next({ name: 'Login' })
  } else {
    next()
  }
})

export default router
